import { Document } from '@tiptap/extension-document'

export const CustomDocument = Document.extend({
  content: 'title subtitle block+',
})
